import { render, staticRenderFns } from "./InclusiveGroupItemConfig.vue?vue&type=template&id=0753fff1&scoped=true"
import script from "./InclusiveGroupItemConfig.vue?vue&type=script&lang=js"
export * from "./InclusiveGroupItemConfig.vue?vue&type=script&lang=js"
import style0 from "./InclusiveGroupItemConfig.vue?vue&type=style&index=0&id=0753fff1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0753fff1",
  null
  
)

export default component.exports